import { getClient, createConsoleLogger, PollingMode, DataGovernance, LogLevel, } from "configcat-js";
import { assignFeatureFlags } from "./assignFeatureFlags";
export let client = null;
export let featureFlagInitialised = null;
/**
 * @warning should be used only in the container of your project — not in
 * micro frontends
 */
export const initFeatureFlags = async ({ featureFlagClientKey, pollIntervalSeconds, logLevel, }) => {
    const logger = createConsoleLogger(logLevel || LogLevel.Error);
    client = getClient(featureFlagClientKey, pollIntervalSeconds ? PollingMode.AutoPoll : PollingMode.ManualPoll, {
        logger,
        dataGovernance: DataGovernance.EuOnly,
        ...(pollIntervalSeconds ? { pollIntervalSeconds } : {}),
    });
    return (client
        .forceRefreshAsync()
        // Assign initial feature flags to window
        .then(() => assignFeatureFlags()));
};
